export default __webpack_public_path__ + "static/media/flag_pt_BR.c0094000.png";